import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Bulk from './Messenger/BulkOld';
import ReportView from './Setting/reportView';

const root = ReactDOM.createRoot(document.getElementById('root'));
const data = {
  ic_photo: "https://data2.unhcr.org/images/documents/big_4cda85d892a5c0b5dd63b510a9c83e9c9d06e739.jpg",
  co_doc_photo: "https://data2.unhcr.org/images/documents/big_4cda85d892a5c0b5dd63b510a9c83e9c9d06e739.jpg",
  bank_statement_photo: "https://data2.unhcr.org/images/documents/big_4cda85d892a5c0b5dd63b510a9c83e9c9d06e739.jpg",
  name: "John Doe",
  nric: "1234567890",
  bank_name: "Example Bank",
  account_no: "9876543210",
  company_name: "Example Company",
  company_registration_no: "ABC123456",
};
root.render(
  <BrowserRouter>
    <Routes>
      <Route path='/' element={<App/>}/>
      <Route path='/test' element={<ReportView />}/>
      
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
